import React from "react";

export function LoadingScreen() {
  return (
    <div className="loading-animation d-flex justify-content-center align-items-center">
      <img src="/assets/images/ball-triangle.svg" alt="loader" className="loader-theme" />
    </div>
  );
}
